var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-button',{attrs:{"variant":"success","size":"sm","disabled":!this.transition && !this.priority ? true : false},on:{"click":function($event){return _vm.saveDetails()}}},[_c('font-awesome-icon',{attrs:{"icon":['fas', 'save']}}),_vm._v("\n    Desar detalls\n   ")],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }